import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap, TimelineMax} from "gsap";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";
import {TheBorderSound} from "../../sound/TheBorderSound";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class TheBorderFreeSpinOutroRunner implements SimplePresentation {

    constructor() {
    }

    public shouldRun(): boolean {
        return (TheBorder.model.data.mode.indexOf(TheBorderGameMode.FREESPIN) > -1 || TheBorder.model.data.mode.indexOf(TheBorderGameMode.FREESPIN_AVALANCHE) > -1)
            && TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL && !TheBorder.model.brokeBank;
    }

    public start(controller: SimplePresentationRunnerController): void {
        const mainTL: TimelineMax = gsap.timeline(),
            amount: number = TheBorder.model.accumulatedRoundWin,
            isTotalWinBelowStake: boolean = TheBorder.isWinBelowStake() || (amount <= TheBorder.model.gameData.playedBetValue),
            isLessThan5Percent: boolean = (amount < (0.05 * TheBorder.getBuyFeaturePrice())),
            outroLoop: string = (isTotalWinBelowStake || isLessThan5Percent ? TheBorderSound.FS_OUTRO_NO_WIN : TheBorderSound.FS_OUTRO),
            countDuration: number = (isTotalWinBelowStake || isLessThan5Percent ? 0 : 1.871);

        TheBorder.scatterSymbols.turnOffAllScatterSymbols();
        TheBorder.xNudgeSymbols.turnOffAllXNudgeSymbols();

        let startDelay = 0.7;
        mainTL.add(gsap.to(this, {duration: startDelay})); //Small delay to allow animations to finish if now win last fs spin.
        mainTL.add(() => {
            TheBorder.keypadPlugin.setZeroBetSpinCounter(-1);
            if (!isTotalWinBelowStake) {
                TheBorder.soundPlayer.playSound(TheBorderSound.FS_END);
            }
            TheBorder.soundPlayer.switchMusic(outroLoop, {
                name: "", to: 0, duration: 200
            });
        });
        mainTL.add(() => controller.setSkipCallback(() => {
            mainTL.seek("end", false);
        }));
        mainTL.add(TheBorder.outroView.showOutro(() => this.fsOutroClosedCallback(controller), amount, countDuration, isLessThan5Percent));
        mainTL.addLabel("end");
        mainTL.add(() => controller.setSkipCallback());
        mainTL.add(TheBorder.outroView.showButton());

        mainTL.add(() => {
        }, 1.2 + startDelay);
    }

    private fsOutroClosedCallback(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.finish();
                TheBorder.isInFS = false;
                TheBorder.buyFeatureName = "";

                if (TheBorder.IS_BOOSTED_BET_ON) {
                    TheBorder.xRipReelHighlighter.highlightReel();
                }
            }
        });
        tl.add(() => {
            TheBorder.xRipButton.show();

            TheBorder.soundPlayer.switchMusic(TheBorderGameMode.NORMAL, {
                name: "", to: 0, duration: 200
            });
        });
        tl.add(TheBorder.outroView.hideOutro());
    }
}